/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ScheduledJobUpdateSpec { 
    /**
     * The name of the job to update, which corresponds to the name of the @Scheduled method
     */
    name: string;
    /**
     * Whether or not this job should run or not
     */
    disabled?: boolean;
    /**
     * The amount of seconds to wait after application startup for this job to run
     */
    initial_delay_seconds?: number;
    /**
     * The amount of seconds in between each job run
     */
    interval_seconds?: number;
    /**
     * The next execution time. Format is YYYY-MM-DD
     */
    next_execution_time?: Date;
}

